<a class="g2-banner" href="https://www.g2.com/products/selfcv/reviews" target="_blank">

  <div class="g2-banner__logo">
    <img src="assets/img/g2-logo.avif" width="36" height="36" loading="lazy" decoding="async" alt="G2">
  </div>

  <div class="g2-banner__content">

    <span class="title">
      Our customers
      <span class="accent">love us ♡</span>
    </span>

    <div class="rating">
      <span class="stars">★★★★★</span>

      <span class="score">
        <strong>5.0</strong>
        <small>out of 5</small>
      </span>
    </div>

    <span class="link">Read reviews on G2 →</span>

    <p class="description">
      We're proud to be highly rated by real users on G2.
    </p>
  </div>

</a>

